export default __webpack_public_path__ + "852859fcb7142aed1938cf0e466af8c5.svg";